import { Sauces } from "../modules";

export const SaucesPage = () => {
  return <>
  <Sauces/>
  </>;
};
